import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { RootState } from '../store';
import { History } from 'history';
import { IonItemDivider, IonLabel, IonIcon, IonMenuButton, IonCard, IonCardHeader, IonCardContent, IonItem, IonAvatar, IonList, IonGrid, IonCol, IonRow, IonButton, IonHeader, IonContent, IonToolbar, IonButtons, IonTitle } from '@ionic/react';
import { Speaker } from '../store/speakers/types';
import { Session } from '../store/sessions/types';


interface ItemProps {
  speaker: Speaker;
  speakerSessions: Session[];
  history: History;
}

const SpeakerItem = ({ speaker, speakerSessions, history }: ItemProps) => {

  function goToLink(e: MouseEvent) {
    if (!e.currentTarget) {
      return;
    }
    e.preventDefault();
    history.push((e.currentTarget as HTMLAnchorElement).href);
  }

  return (
    <IonCard class="speaker-card" color="dark">
      <IonCardHeader color="dark">
        <IonItem
          button
          detail={false}
          href={`/speakers/speaker/${speaker.id}`}
          onClick={goToLink}
        >
          <IonAvatar slot="start">
            <img src={process.env.PUBLIC_URL + speaker.profilePic} alt="Speaker profile pic"/>
          </IonAvatar>
          {speaker.name}
        </IonItem>
      </IonCardHeader>

      <IonCardContent class="outer-content">
        <IonList>
          { speakerSessions.map(session => (
            <IonItem
              href={`/speakers/sessions/${session.id}`}
              key={session.name}
              onClick={goToLink}
            >
              <h3>{session.name}</h3>
            </IonItem>
          ))}
          <IonItem button href={`/speakers/speaker/${speaker.id}`} onClick={goToLink}>
            <h3>{speaker.about.substring(0,100)}...</h3>
          </IonItem>
        </IonList>
      </IonCardContent>
    </IonCard>
  );
};

type ListProps = RouteComponentProps & ReturnType<typeof mapStateToProps>;

const SpeakerList = ({ speakers, sessions, history }: ListProps) => (
  <>
    <IonHeader>
      <IonToolbar color="dark">
        <IonButtons slot="start">
          <IonMenuButton></IonMenuButton>
        </IonButtons>
        <IonTitle>Who's Here?</IonTitle>
      </IonToolbar>
    </IonHeader>

    <IonContent color="dark" class="outer-content speaker-list">
      <IonList>
      <IonItemDivider sticky color="dark">
            <IonTitle>
              Sponsors
            </IonTitle>
          </IonItemDivider>
        <IonGrid fixed>
          <IonRow align-items-stretch>
            { speakers.filter(s => s.type == "sponsor").map((speaker) =>
              <IonCol size="12" size-md="6" key={speaker.id}>
                <SpeakerItem
                  speaker={speaker}
                  history={history}
                  speakerSessions={sessions.filter(session => session.speakerIds.indexOf(speaker.id) !== -1)}
                />
              </IonCol>
            ) }
          </IonRow>
        </IonGrid>
        <IonItemDivider sticky color="dark">
            <IonTitle>
              Speakers
            </IonTitle>
          </IonItemDivider>
        <IonGrid fixed>
          <IonRow align-items-stretch>
            { speakers.filter(s => s.type == "speaker").map((speaker) =>
              <IonCol size="12" size-md="6" key={speaker.id}>
                <SpeakerItem
                  speaker={speaker}
                  history={history}
                  speakerSessions={sessions.filter(session => session.speakerIds.indexOf(speaker.id) !== -1)}
                />
              </IonCol>
            ) }
          </IonRow>
        </IonGrid>
        <IonItemDivider sticky color="dark">
            <IonTitle>
              Food Vendors
            </IonTitle>
          </IonItemDivider>
        <IonGrid fixed>
          <IonRow align-items-stretch>
            { speakers.filter(s => s.type == "food").map((speaker) =>
              <IonCol size="12" size-md="6" key={speaker.id}>
                <SpeakerItem
                  speaker={speaker}
                  history={history}
                  speakerSessions={sessions.filter(session => session.speakerIds.indexOf(speaker.id) !== -1)}
                />
              </IonCol>
            ) }
          </IonRow>
        </IonGrid>
        <IonItemDivider sticky color="dark">
            <IonTitle>
              Vendors
            </IonTitle>
          </IonItemDivider>
        <IonGrid fixed>
          <IonRow align-items-stretch>
            { speakers.filter(s => s.type == "vendor").map((speaker) =>
              <IonCol size="12" size-md="6" key={speaker.id}>
                <SpeakerItem
                  speaker={speaker}
                  history={history}
                  speakerSessions={sessions.filter(session => session.speakerIds.indexOf(speaker.id) !== -1)}
                />
              </IonCol>
            ) }
          </IonRow>
        </IonGrid>
        <IonItemDivider sticky color="dark">
            <IonTitle>
              Visiting Groups
            </IonTitle>
          </IonItemDivider>
        <IonGrid fixed>
          <IonRow align-items-stretch>
            { speakers.filter(s => s.type == "group").map((speaker) =>
              <IonCol size="12" size-md="6" key={speaker.id}>
                <SpeakerItem
                  speaker={speaker}
                  history={history}
                  speakerSessions={sessions.filter(session => session.speakerIds.indexOf(speaker.id) !== -1)}
                />
              </IonCol>
            ) }
          </IonRow>
        </IonGrid>
      </IonList>
    </IonContent>
  </>
);

const mapStateToProps = (state: RootState) => ({
  speakers: state.speakers.speakers,
  sessions: state.sessions.sessions
});

export default connect(
  mapStateToProps
)(SpeakerList);
